// Host + route helpers — bare and www variants per brand domain.
const HOST = window.location.hostname.toLowerCase();

const INC_HOSTS = ["eagle-inc.al", "www.eagle-inc.al", "eagle-inc.net", "www.eagle-inc.net", "eagle-inc.eu", "www.eagle-inc.eu"];
const EYES_HOSTS = ["eagle-eyes.al", "www.eagle-eyes.al"];
const COMMERCE_HOSTS = ["eagle-commerce.al", "www.eagle-commerce.al"];
const DIGITAL_HOSTS = ["digital-services.al", "www.digital-services.al"];
const PRODUCT_HOST_INDEX = {
  "socialdeal.al": 0, "www.socialdeal.al": 0,
  "bookitnow.al": 1, "www.bookitnow.al": 1,
  "incontact.al": 2, "www.incontact.al": 2,
};

export const ON_INC_HOST = INC_HOSTS.includes(HOST);
export const ON_EYES_HOST = EYES_HOSTS.includes(HOST);
export const ON_COMMERCE_HOST = COMMERCE_HOSTS.includes(HOST);
export const ON_DIGITAL_HOST = DIGITAL_HOSTS.includes(HOST);
export const PRODUCT_HOST = HOST in PRODUCT_HOST_INDEX ? PRODUCT_HOST_INDEX[HOST] : null;
export const ON_PRODUCT_HOST = PRODUCT_HOST !== null;

// Hierarchy bases — on a brand's own host the base is "/", elsewhere nested under eagle-inc.*
export const EYES_BASE = ON_EYES_HOST ? "" : "/eagle-eyes";
export const RE_BASE = ON_EYES_HOST ? "/realestate" : `${EYES_BASE}/real-estate`;
export const IT_BASE = ON_EYES_HOST ? "/it-management" : `${EYES_BASE}/it-management`;
export const DIGITAL_BASE = ON_EYES_HOST || ON_DIGITAL_HOST ? "/digital-services" : `${EYES_BASE}/digital-services`;
export const COMMERCE_BASE = ON_COMMERCE_HOST ? "/" : "/eagle-commerce";
export const PRODUCT_ROUTES = ON_COMMERCE_HOST
  ? ["/socialdeal", "/bookitnow", "/incontact"]
  : ["/eagle-commerce/socialdeal", "/eagle-commerce/bookitnow", "/eagle-commerce/incontact"];
// On a product's own host (socialdeal.al etc.) the header never links "up" to the group layer
export const PRODUCT_HOME = ON_PRODUCT_HOST ? "/" : COMMERCE_BASE;
